import { gql } from "@apollo/client";

const GET_INVOICE_READER_TEMPLATE = gql`
  query invoiceReaderTemplate($clientIdentifier: String!, $id: String!) {
    invoiceReaderTemplate(clientIdentifier: $clientIdentifier, id: $id) {
      id
      eInvoiceTested
      file {
        id
        content
      }
      mappedRowFieldCount
      modifiedAt
      name
      notes
      state
      templateLanguage
      templateType
      extraction {
        docstrumSettings {
          betweenLineDistance
          withinLineDistance
          withinLineLowerBound
          withinLineMultiplier
          withinLineUpperBound
        }
        extractionSettings {
          dateFormat
        }
        fieldExtractionData {
          fieldType
          isRequired
          label {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
          value {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
        }
        maskingData {
          label {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
          maskingType
          value {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
        }
        possibleFieldValues {
          pageNumber
          position {
            bottomLeftX
            bottomLeftY
            topRightX
            topRightY
          }
          value
        }
        rowExtractionData {
          columnHeader {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
          columnHeaderType
          isFixedPosition
        }
        ignoredHeaders
        stampInformation {
          alternativeStampPositions {
            bottomLeftX
            bottomLeftY
            topRightX
            topRightY
          }
          bankText
          bankTextValue
          label {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
          paymentText
          paymentTextValue
          position {
            bottomLeftX
            bottomLeftY
            topRightX
            topRightY
          }
          stampAllPages
          text
        }
        verifierPositions {
          extractionVerifier {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
          verifierLabel {
            position {
              bottomLeftX
              bottomLeftY
              topRightX
              topRightY
            }
            value
          }
        }
      }
    }
  }
`;

export default GET_INVOICE_READER_TEMPLATE;
